exports.random = function(n) {
  return Math.floor(n * Math.random());
};
